import React, { Component } from 'react';
import { hideHeader } from '../constants/functions';
import { sendToServer } from '../constants/network';
import BreadCrumb from './Breadcrumbs';
import routes from '../constants/routes';

export default class extends Component {
    state = {
        sending: false
    };

    formData = {
        nombre: '',
        telefono: '',
        email: '',
        asunto: '',
        mensaje: ''
    };

    componentDidMount = () => setTimeout(hideHeader);

    render = () => {
        let buttonContent = <span>Enviar</span>;
        if (this.state.sending) {
            buttonContent = <span className='fa fa-fw fa-circle-o-notch fa-spin'/>;
        }
        return (
            <div>
                <div id='cambio-sector' className='selva'>
                    <div className='contenedor-sector'>
                        <BreadCrumb links={[
                            { url: '', text: 'Contáctanos' }
                        ]}/>
                    </div>
                </div>
                <div className='col-sm-6 col-sm-offset-3'>
                    <form className='form-horizontal contacto-form' onSubmit={this.submit}>
                        <h4>Contáctanos:</h4>
                        <div className='form-group'>
                            <label className='control-label col-sm-2'>Nombre</label>
                            <div className='col-sm-10'>
                                <input type='text' className='form-control' name='nombre' onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label className='control-label col-sm-2'>Teléfono</label>
                            <div className='col-sm-10'>
                                <input type='text' className='form-control' name='telefono'
                                       onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label className='control-label col-sm-2'>Email</label>
                            <div className='col-sm-10'>
                                <input type='text' className='form-control' name='email' onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label className='control-label col-sm-2'>Asunto</label>
                            <div className='col-sm-10'>
                                <input type='text' className='form-control' name='asunto' onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className='form-group'>
                            <label className='control-label col-sm-2'>Mensaje</label>
                            <div className='col-sm-10'>
                                <textarea className='form-control' rows='10' name='mensaje'
                                          onChange={this.handleChange}/>
                            </div>
                        </div>
                        <div className='form-group'>
                            <div className='col-sm-offset-6 col-sm-2' style={{ padding: 0 }}>
                                <button className='btn btn-default btn-block'>
                                    {buttonContent}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    handleChange = (e) => {
        this.formData[e.target.name] = e.target.value;
    };

    submit = (e) => {
        e.preventDefault();
        this.setState({
            sending: true
        });

        sendToServer(routes.contacto, 'POST', this.formData)
            .then(() => {
                this.setState({
                    sending: false
                });
                document.location = '/';
            });
    }
}


// WEBPACK FOOTER //
// ./src/components/ContactoForm.js